import fetch from '@/utils/fetch';
import * as API from '@/commons/http-api';

export default {
  namespace: 'home',
  state: {
    userId: '',
    pageNum: '',
    pageLimit: '',
    totall: '',
    level: '',
    loading: false,
    dataSource: [],
    AllDataSource: [],
    meetingId: '',
    userId: '',
    updateStatus: '',
  },
  reducers: {
    setDataSource(state, action) {
      const { AllDataSource, pageNum } = state;
      if (pageNum !== action.payload.pageNum) {
        let DataSource = AllDataSource.concat(action.payload.records);
        return {
          ...state,
          pageNum: action.payload.pageNum,
          AllDataSource: DataSource,
          totall: action.payload.total,
          dataSource: DataSource,
          loading: false,
        };
      } else {
        return {
          ...state,
          pageNum: action.payload.pageNum,
          totall: action.payload.total,
          loading: false,
        };
      }
      // console.log(state)
    },
    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload,
      };
    },
    setLevel(state, action) {
      return {
        ...state,
        level: action.payload,
      };
    },
    setStatusMeeting(state, action) {
      // const { meetingId, userId, updateStatus } = action.payload;
      return {
        ...state,
        statusMeeting: action.payload,
      };
    },
    setOriginDataSource(state, action) {
      const { pageNum, AllDataSource, totall, dataSource } = action.payload;
      return {
        ...state,
        pageNum,
        AllDataSource,
        totall,
        dataSource,
      };
    },
  },
  effects: {
    *getDataSource(action, { put }) {
      yield put({
        type: 'setLoading',
        payload: true,
      });
      const { pageLimit, pageNum } = action.payload;
      if (pageNum === 1) {
        yield put({
          type: 'setOriginDataSource',
          payload: { pageNum: '', records: [], AllDataSource: [], dataSource: [], totall: '' },
        });
      }
      const res = yield fetch.get(API.MEETING_GET_LIST, { pageNum, pageLimit });
      yield put({
        type: 'setDataSource',
        payload: res.data,
      });
    },
    *getLevel(action, { put }) {
      const res = yield fetch.get(API.MEETING_GET_USERLEVEL);
      yield put({
        type: 'setLevel',
        payload: res.data,
      });
    },
    *getStatusMeeting(action, { put }) {
      const { meetingId, userId, updateStatus } = action.payload;
      const res = yield fetch.post(API.MEETING_UPDATESTATUS, { meetingId, userId, updateStatus });
      yield put({
        type: 'setStatusMeeting',
        payload: res.data,
      });
    },
  },
};
